import React from "react";
import { Button, ButtonProps } from "antd";

interface IButtonProps extends ButtonProps {
  variant?: "sm" | "md" | "lg" | "xl" | "2xl" | "full";
  vType?: "primary" | "secondary" | "secondary-color" | "tertiary" | "tertiary-color" | "link" | "link-color" | "danger";
  hasIcon?: boolean;
  fullWidth?: boolean;
}

export default function RawButton(
  props: IButtonProps & React.RefAttributes<HTMLElement>
) {
  const { fullWidth, style, className, ...rest } = props;

  // If fullWidth is true, force the wrapper span to be block-level and 100% width.
  const wrapperStyle = fullWidth
    ? { display: "block", width: "100%", ...style }
    : style;

  return (
    <span className={className} style={wrapperStyle}>
      <Button
        {...rest}
        className={`app-btn-${props.variant} app-btn-${props.vType} ${
          props.hasIcon ? "app-btn-icon" : ""
        }`}
      />
    </span>
  );
}
